module.exports = __webpack_public_path__ + "static/media/greenCircle.15254f15.svg";